module.exports = __webpack_public_path__ + "static/img/166_TO8_1907_og.b6e182d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/166_TO8_1907_og.jpg
// module id = 4gdK
// module chunks = 0